import React from 'react';
import { useTranslation } from 'react-i18next';

import './index.less';

import { AgentMessageEventHandoffData } from '../../../../gamma-api';
import IbIcon from '../../common/IbIcon';
import IbTypography from '../../common/IbTypography';
import IbCollapse, { IbCollapsePanel } from '../../common/IbCollapse';
import MarkdownContent from '../../MarkdownContent';
import { agentMessageEventDataToMarkdown } from '../utils';

const MAIN_CLASS_NAME = 'handoff-event-details';
const OUTPUT_PANEL_CLASS_NAME = `${MAIN_CLASS_NAME}__output-panel`;

export interface IHandoffEventDetailsProps {
  handoffData: AgentMessageEventHandoffData;
}

const HandoffEventDetails: React.FC<IHandoffEventDetailsProps> = ({ handoffData }) => {
  const { t } = useTranslation();

  return (
    <IbCollapse
      accordion={false}
      className={MAIN_CLASS_NAME}
      defaultActiveKey={['output']}
      expandIcon={({ isActive }) => <IbIcon iconName={isActive ? 'down' : 'up'} size={20} />}
      expandIconPosition="right"
    >
      <IbCollapsePanel
        key="output"
        className={OUTPUT_PANEL_CLASS_NAME}
        header={
          <IbTypography.Paragraph strong type="secondary">
            {t('Agent: Handoff event details: Output')}
          </IbTypography.Paragraph>
        }
      >
        <MarkdownContent>{agentMessageEventDataToMarkdown(handoffData)}</MarkdownContent>
      </IbCollapsePanel>
    </IbCollapse>
  );
};

export default HandoffEventDetails;
